class MedicationPriceController {
  /* @ngInject */
  constructor($log, $interval, toastr, $http, Endpoints, MailOrderPharmacies, Business, Services, MedicationPrice, Auth) {
    Object.assign(this, {
      $log,
      $interval,
      $http,
      Endpoints,
      MailOrderPharmacies,
      Business,
      Services,
      MedicationPrice,
      toastr,
      Auth,
      selectedPharm: null,
      results: [],
      states: [],
      services: [],
      pharmacies: [],
      editing: false,
      allSelected: false,
      processing: false,
      num_to_process: 0
    });
    this.getAllServices();
    this.getAllPharmacies();
  }

  getAllPharmacies() {
    this.MailOrderPharmacies.getAllPharmacies().then(({
      data
    }) => {
      data.forEach(pharmacy => {
        pharmacy.id = pharmacy.pharmacy_id;
        pharmacy.id_string = "" + pharmacy.pharmacy_id;
        pharmacy.search = pharmacy.name;
      });
      this.pharmacies = data;
      var elem = {
        id: 0,
        "id_string": "0",
        "name": "All Pharmacies",
        "search": ""
      };
      this.pharmacies.unshift(elem);
      this.selectedPharmacy = this.pharmacies[0];
    }).catch(err => {
      this.pharmacies = [];
      this.toastr.error('Error getting all pharmacies: ' + JSON.stringify(err));
    });
  }

  getAllServices() {
    this.Services.list().then(({
      data
    }) => {
      let servicesArr = [];

      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].children) {
          for (let j = 0; j < data.data[i].children.length; j++) {
            // console.log(data.data[i].children[j]);
            servicesArr.push({
              id: data.data[i].children[j].id,
              code: data.data[i].children[j].code,
              name: data.data[i].children[j].name + " (" + data.data[i].children[j].code + ")"
            });
          }

          continue;
        }

        servicesArr.push({
          id: data.data[i].id,
          code: data.data[i].code,
          name: data.data[i].name + " (" + data.data[i].code + ")"
        });
      }

      servicesArr.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
      var elem = {
        "id": 0,
        "code": "SELECT",
        "name": "Select a service"
      };
      servicesArr.unshift(elem);
      this.services = servicesArr; // console.log(this.services)

      this.selectedService = "SELECT";
    }).catch(err => {
      this.services = [];
      this.toastr.error('Error getting all services: ' + JSON.stringify(err));
    });
  }

  getMedsByService(service) {
    this.MedicationPrice.getMedsByService(service).then(({
      data
    }) => {
      this.results = data;
    }).catch(err => {
      this.results = [];

      if (err && err.data && err.data.error && err.data.error.message) {
        this.toastr.error('Error: ' + err.data.error.message);
      } else {
        this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
      }
    });
  }

  select(row) {
    if (!row['selected']) {
      row['selected'] = true;
    } else {
      row['selected'] = false;
    }

    this.num_to_process = 0;
    this.filteredResults.forEach(result => {
      if (result['selected']) this.num_to_process++;
    });

    if (this.filteredResults.length && this.num_to_process === this.filteredResults.length) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
  }

  selectAll() {
    if (!this.allSelected) {
      this.filteredResults.forEach(result => {
        result['selected'] = true;
      });
      this.allSelected = true;
      this.num_to_process = this.filteredResults.length;
    } else {
      this.filteredResults.forEach(result => {
        result['selected'] = false;
      });
      this.allSelected = false;
      this.num_to_process = 0;
    }
  }

  add(result) {
    this.adding = true;
    this.currentlyEditing = result;
    this.currentlyEditing.originalPrice = 0;
    this.currentlyEditing.medication_price = 0;
    this.selectedPharmacyForEditing = this.pharmacies[0];
  }

  edit(result) {
    this.editing = true;
    this.currentlyEditing = result;
    this.currentlyEditing.originalPrice = this.currentlyEditing.medication_price;
    this.currentlyEditing.medication_price = result.medication_price;
  }

  cancel() {
    this.editing = false;
    this.adding = false;
  }

  delete(current) {
    let audit = {};
    audit.user_id = this.Auth.profile.id;
    audit.action_cd = 'DELETE';
    audit.medication_id = current.medication_id;
    audit.pharmacy_id = current.pharmacy_id;
    audit.field = 'price';
    audit.was = current.medication_price;
    audit.now = 'NULL'; // audit.timestamp = Date.now();

    var now = new Date().getTime();
    audit.timestamp = parseInt(now / 1000);
    this.MedicationPrice.deleteMedication(current.medication_pharmacy_price_id).then(() => {
      this.MedicationPrice.audit(audit).then(() => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully deleted');
        this.getMedsByService(this.selectedService);
      }).catch(err => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully deleted');

        if (err && err.data && err.data.message) {
          this.toastr.error('Error: ' + err.data.message);
        } else {
          this.toastr.error('Error auditing medication price delete: ' + JSON.stringify(err));
        }

        this.getMedsByService(this.selectedService);
      });
    }).catch(err => {
      if (err && err.data && err.data.message) {
        this.toastr.error('Error: ' + err.data.message);
      } else {
        this.toastr.error('Error deleting medication price: ' + JSON.stringify(err));
      }
    });
  }

  update(current) {
    let audit = {}; // current.pharmacy_id = this.selectedPharmacyForEditing.id;

    current.medication_price = current.medication_price ? current.medication_price : 0;
    audit.user_id = this.Auth.profile.id;
    audit.action_cd = 'UPDATE';
    audit.medication_id = current.medication_id;
    audit.pharmacy_id = current.pharmacy_id;
    audit.field = 'price';
    audit.was = current.originalPrice;
    audit.now = current.medication_price; // audit.timestamp = Date.now();

    var now = new Date().getTime();
    audit.timestamp = parseInt(now / 1000);
    this.MedicationPrice.updatePrice(current.medication_pharmacy_price_id, current.pharmacy_id, current.medication_price).then(() => {
      this.MedicationPrice.audit(audit).then(() => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully updated');
        this.getMedsByService(this.selectedService);
      }).catch(err => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully updated');

        if (err && err.data && err.data.message) {
          this.toastr.error('Error: ' + err.data.message);
        } else {
          this.toastr.error('Error auditing medication price update: ' + JSON.stringify(err));
        }

        this.getMedsByService(this.selectedService);
      });
    }).catch(err => {
      if (err && err.data && err.data.message) {
        this.toastr.error('Error: ' + err.data.message);
      } else {
        this.toastr.error('Error updating medication price: ' + JSON.stringify(err));
      }
    });
  }

  create(current) {
    let audit = {};

    if (this.selectedPharmacyForEditing.id == 0) {
      this.toastr.warning('Please select a pharmacy.');
      return;
    }

    current.medication_price = current.medication_price ? current.medication_price : 0;
    current.pharmacy_id = this.selectedPharmacyForEditing.id;
    audit.user_id = this.Auth.profile.id;
    audit.action_cd = 'INSERT';
    audit.medication_id = current.medication_id;
    audit.pharmacy_id = current.pharmacy_id;
    audit.field = 'price';
    audit.was = '';
    audit.now = current.medication_price; // audit.timestamp = Date.now();

    var now = new Date().getTime();
    audit.timestamp = parseInt(now / 1000);
    this.MedicationPrice.addMedicationPrice(current.medication_id, current.pharmacy_id, current.medication_price).then(() => {
      this.MedicationPrice.audit(audit).then(() => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully created');
        this.getMedsByService(this.selectedService);
      }).catch(err => {
        this.editing = false;
        this.adding = false;
        this.currentlyEditing = null;
        this.toastr.success('Medication price successfully created');

        if (err && err.data && err.data.message) {
          this.toastr.error('Error: ' + err.data.message);
        } else {
          this.toastr.error('Error auditing medication price insert: ' + JSON.stringify(err));
        }

        this.getMedsByService(this.selectedService);
      });
    }).catch(err => {
      if (err && err.data && err.data.message) {
        this.toastr.error('Error: ' + err.data.message);
      } else {
        this.toastr.error('Error creating medication price: ' + JSON.stringify(err));
      }
    });
  }

}

MedicationPriceController.$inject = ["$log", "$interval", "toastr", "$http", "Endpoints", "MailOrderPharmacies", "Business", "Services", "MedicationPrice", "Auth"];
angular.module('pims').controller('MedicationPriceController', MedicationPriceController);